import { Component } from '@angular/core';
import { NavController, NavParams, App, InfiniteScroll } from 'ionic-angular';
import { ResultProvider, ResultSearchModel, RanglistListModel, RanglistSearchModel, ResultSearchAdvancedModel } from '../../../providers/result/result';
import { EventTievts, EventProvider, EventDetailsModel } from '../../../providers/event/event';
import { LoaderProvider } from '../../../providers/loader/loader';
import { TranslateService } from '@ngx-translate/core';
import { ValueProvider } from '../../../providers/value/value';
import { SessionProvider } from '../../../providers/session/session';
import { MysportUserProfilePage } from '../../me/mysport/mysport-user-profile/mysport-user-profile';
import { ArrayType, ThrowStmt } from '@angular/compiler/src/output/output_ast';
import { GpsTracker } from '../../../tracker/gps-tracker';
import { GlobalUtil } from '../../../tracker/global-utils';
import { AppDetectorProvider } from '../../../providers/detector/detector';
import { ConfigProvider } from '../../../providers/config/config';

/**
 * Generated class for the ResoultRanglistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
    selector: 'page-result-event-details',
    templateUrl: 'result-event-details.html',
})
export class ResultEventDetailsPage {
    searchModel: ResultSearchAdvancedModel = { eid: '', ena: '', city: '', dt: '', dist: '', t: '', sw: '', page: null, start: null, limit: null };
    savedSearch: ResultSearchAdvancedModel;

    event: EventTievts;
    list: RanglistListModel[] = [];

    search: RanglistSearchModel;
    results: any;

    eventDates: any = [];
    eventDistances: any = [];
    eventTypes: any = [];

    isBrowser: boolean = false;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public eventService: EventProvider,
        public resultService: ResultProvider,
        public valueService: ValueProvider,
        public loadingCtrl: LoaderProvider,
        public app: App,
        public translate: TranslateService,
        private sessionService: SessionProvider,
        private appDetector: AppDetectorProvider,
        private config: ConfigProvider) {

    }

    onSearch() {
        console.log(this.event);
        this.searchModel.page = null;
        this.searchModel.start = '0';
        this.searchModel.limit = '25';

        this.getResults();
    }

    getResults() {
        console.log(this.searchModel);
        this.valueService.getResultsRangList(this.searchModel).then(data => {
            this.list = data.sort((a, b) => a.place - b.place);
            console.log('list: ', this.list);
        });
    }

    onDateChanged() {
        console.log(this.searchModel);
        this.valueService.getUserWithResults(this.searchModel.ena, this.searchModel.city, this.searchModel.dt).then(distances => {
            this.eventDistances = distances;
            if (distances.length > 0) {
                this.searchModel.dist = distances[0].value;
                this.onDistChanged();
            }
        });
    }

    onDistChanged() {
        console.log(this.searchModel);

        this.valueService.getUserEventTypeWithResults(this.searchModel.ena, this.searchModel.city, this.searchModel.dt, this.searchModel.dist).then(types => {
            this.eventTypes = types;
            if (types.length > 0) {
                this.searchModel.t = types[0].value;
            }
            this.onSearch();
        });
    }

    onTypeChanged() {
        this.onSearch();
    }

    onInputChange() {
        this.onSearch();
    }

    ionViewWillLoad() {
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();

        this.event = this.navParams.get('eventDetails');
        this.search = this.navParams.get('search');

        GlobalUtil.getInstance().currentEventID = this.event.id;

        this.valueService.getEventDatesWithResults(this.event.eventName, this.event.ort).then(dates => {
            this.eventDates = dates;

            this.valueService.getUserWithResults(this.event.eventName, this.event.ort, this.eventDates[this.eventDates.length - 1].value).then(distances => {
                this.eventDistances = distances;

                this.valueService.getUserEventTypeWithResults(this.event.eventName, this.event.ort, this.eventDates[this.eventDates.length - 1].value, this.eventDistances[this.eventDistances.length - 1].value).then(types => {
                    this.eventTypes = types;

                    this.searchModel.eid = this.event.id;
                    this.searchModel.ena = this.event.eventName;
                    this.searchModel.city = this.event.ort;
                    this.searchModel.dt = this.eventDates[0].value;
                    this.searchModel.dist = this.eventDistances[this.eventDistances.length - 1].value;
                    this.searchModel.t = this.eventTypes[this.eventTypes.length - 1].value;

                    loader.dismiss();
                });
            });
        });

    }

    isLoged() {
        return this.sessionService.isLoged;
    }

    async onBack() {
        this.isBrowser = (await this.config.config).platform.browser;

        if (this.appDetector.isEventsApp() && this.isBrowser) {
            (this.app.getRootNav() as NavController).pop();
        } else {
            this.navCtrl.popToRoot();
            this.app.getRootNav().getActiveChildNav().select(1);
        }
    }

    showLogin() {
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();
        let profile = this.sessionService.isLoged ? this.sessionService.profile : null;
        this.valueService.getProfileBackgrounds().then(backgrounds => {
            (this.app.getRootNav() as NavController)
                .push(MysportUserProfilePage, { data: { profile: profile, backgrounds: backgrounds } })
                .then(() => loader.dismiss());
        });
    }

    profileImage(): string {
        return this.sessionService.profile.profilePicLink || 'assets/imgs/default-image-32@1x.png';
    }

    loadNextPage(event: InfiniteScroll) {
        this.valueService.getResultsRangList(this.searchModel).then(data => {
            console.log('data: ', data);
            this.list = data;
            // this.list = this.list.concat(data);
            // console.log('this.list: ', this.list);
            // this.list = this.list.sort((a, b) => a.place - b.place);
            event.complete();
        });
    }
}



// WEBPACK FOOTER //
// /src/pages/results/result-event-details/result-event-details.ts